import { InjectionToken } from '@angular/core';

/** Base URL for HTTP calls; both portal and admin should provide the same contract. */
export const API_BASE_URL = new InjectionToken<string>('API_BASE_URL');

export function provideApiBaseUrl(url: string) {
  return { provide: API_BASE_URL, useValue: url };
}
